<app-topbar *ngIf="!fullScreenPage"></app-topbar>

<app-hero [title]="pagetitle" *ngIf="!fullScreenPage"></app-hero>

<router-outlet></router-outlet>

<app-footer *ngIf="!fullScreenPage"></app-footer>
